import { render, staticRenderFns } from "./ExerciseSolution.vue?vue&type=template&id=1f2f9bab"
import script from "./ExerciseSolution.vue?vue&type=script&lang=js"
export * from "./ExerciseSolution.vue?vue&type=script&lang=js"
import style0 from "./ExerciseSolution.vue?vue&type=style&index=0&id=1f2f9bab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports